import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

// Materials
export const getMaterials = (params) => axios.get(`${API}/materials`, { params });
export const getMaterial = (id) => axios.get(`${API}/materials/${id}`);
export const getSimilarMaterials = (id, limit = 4) => axios.get(`${API}/materials/${id}/similar`, { params: { limit } });
export const createMaterial = (data) => axios.post(`${API}/materials`, data);
export const updateMaterial = (id, data) => axios.put(`${API}/materials/${id}`, data);
export const deleteMaterial = (id) => axios.delete(`${API}/materials/${id}`);
export const archiveMaterial = (id) => axios.put(`${API}/materials/${id}/archive`);
export const releaseMaterialExternal = (id) => axios.put(`${API}/materials/${id}/release-external`);
export const getMySiteMaterials = (params) => axios.get(`${API}/materials/my-site`, { params });

// SKUs
export const getSKU = (id) => axios.get(`${API}/skus/${id}`);
export const createSKU = (data) => axios.post(`${API}/skus`, data);
export const updateSKU = (id, data) => axios.put(`${API}/skus/${id}`, data);
export const releaseSkuExternal = (id) => axios.put(`${API}/skus/${id}/release-external`);

// Standard Materials
export const getStandardMaterials = (params) => axios.get(`${API}/standard-materials`, { params });
export const createStandardMaterial = (data) => axios.post(`${API}/standard-materials`, data);
export const updateStandardMaterial = (id, data) => axios.put(`${API}/standard-materials/${id}`, data);
export const deleteStandardMaterial = (id) => axios.delete(`${API}/standard-materials/${id}`);
export const uploadStandardMaterials = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/standard-materials/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getStandardMaterialsTemplate = () => axios.get(`${API}/standard-materials/template`, { responseType: 'blob' });
export const getStandardMaterialMatches = () => axios.get(`${API}/standard-materials/matches`);
export const getSavingForMaterial = (materialId) => axios.get(`${API}/standard-materials/saving/${materialId}`);

// User Notifications
export const getUserNotifications = (limit = 50) => axios.get(`${API}/notifications`, { params: { limit } });
export const getUnreadNotificationCount = () => axios.get(`${API}/notifications/unread-count`);
export const markNotificationRead = (id) => axios.put(`${API}/notifications/${id}/read`);
export const markAllNotificationsRead = () => axios.put(`${API}/notifications/read-all`);

// Categories
export const getCategories = () => axios.get(`${API}/categories`);
export const getCategoriesFlat = () => axios.get(`${API}/categories/flat`);
export const createCategory = (data) => axios.post(`${API}/categories`, data);
export const updateCategory = (id, data) => axios.put(`${API}/categories/${id}`, data);
export const deleteCategory = (id) => axios.delete(`${API}/categories/${id}`);

// Sites
export const getSites = (groupId) => axios.get(`${API}/sites`, { params: { group_id: groupId } });
export const getSitesPublic = () => axios.get(`${API}/sites/search-options`);
export const getSite = (id) => axios.get(`${API}/sites/${id}`);
export const createSite = (data) => axios.post(`${API}/sites`, data);
export const updateSite = (id, data) => axios.put(`${API}/sites/${id}`, data);
export const deleteSite = (id) => axios.delete(`${API}/sites/${id}`);

// Groups
export const getGroups = () => axios.get(`${API}/groups`);
export const getGroup = (id) => axios.get(`${API}/groups/${id}`);
export const createGroup = (data) => axios.post(`${API}/groups`, data);
export const updateGroup = (id, data) => axios.put(`${API}/groups/${id}`, data);
export const deleteGroup = (id) => axios.delete(`${API}/groups/${id}`);
export const switchGroup = (groupId) => axios.put(`${API}/auth/switch-group`, { group_id: groupId });

// Requests
export const getRequests = (params) => axios.get(`${API}/requests`, { params });
export const getGroupIncomingRequests = (params) => axios.get(`${API}/requests`, { params: { ...params, group_incoming: true } });
export const createRequest = (data) => axios.post(`${API}/requests`, data);
export const updateRequestStatus = (id, data) => axios.put(`${API}/requests/${id}/status`, data);
export const getPendingIncomingRequestsCount = () => axios.get(`${API}/requests/pending-incoming-count`);

// Watchlist
export const getWatchlist = () => axios.get(`${API}/watchlist`);
export const addToWatchlist = (materialId) => axios.post(`${API}/watchlist/${materialId}`);
export const removeFromWatchlist = (materialId) => axios.delete(`${API}/watchlist/${materialId}`);

// Dashboard
export const getGlobalDashboard = () => axios.get(`${API}/dashboard/global`);
export const getSiteDashboard = (siteId) => axios.get(`${API}/dashboard/site/${siteId}`);
export const getScenarioPreview = (data) => axios.post(`${API}/dashboard/scenario-preview`, data);

// Group Materials
export const getMyGroupMaterials = (params) => axios.get(`${API}/materials/my-group`, { params });

// Sustainability
export const getSustainability = () => axios.get(`${API}/sustainability`);
export const downloadSustainabilityReport = (params) => axios.get(`${API}/sustainability/report`, { params, responseType: 'blob' });

// Admin
export const getScenarioSettings = (groupId) => axios.get(`${API}/admin/settings/scenario`, { params: groupId ? { group_id: groupId } : {} });
export const updateScenarioSettings = (data) => axios.put(`${API}/admin/settings/scenario`, data);
export const getScenarioImpact = (groupId) => axios.get(`${API}/admin/settings/scenario/impact`, { params: groupId ? { group_id: groupId } : {} });
export const seedData = () => axios.post(`${API}/admin/seed`);
export const seedTranslations = () => axios.post(`${API}/admin/seed-translations`);
export const getUsers = () => axios.get(`${API}/admin/users`);
export const approveUser = (userId, approved) => axios.put(`${API}/admin/users/${userId}/approve`, { approved });
export const updateUserRole = (userId, role, siteId) => axios.put(`${API}/admin/users/${userId}/role`, { role, site_id: siteId });
export const deleteUser = (userId) => axios.delete(`${API}/admin/users/${userId}`);
export const getAuditLog = (params) => axios.get(`${API}/admin/audit-log`, { params });

// Import/Export
export const getImportTemplate = () => axios.get(`${API}/import/template`);
export const downloadImportTemplate = () => axios.get(`${API}/import/template/download`, { responseType: 'blob' });
export const validateImport = (data) => axios.post(`${API}/import/validate`, data);
export const executeImport = (rows, mode, selectedFields) => 
  axios.post(`${API}/import/execute`, { rows, mode, selected_fields: selectedFields });
export const exportMaterials = (params) => axios.get(`${API}/export`, { params });

// Attachments
export const getAttachments = (materialId) => axios.get(`${API}/attachments`, { params: { material_id: materialId } });
export const createAttachment = (data) => axios.post(`${API}/attachments`, data);
export const deleteAttachment = (id) => axios.delete(`${API}/attachments/${id}`);

// File Upload
export const uploadFile = (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
};

// Material Master Data
export const getMasterData = (params) => axios.get(`${API}/master-data`, { params });
export const getPendingMasterData = () => axios.get(`${API}/master-data/pending`);
export const createMasterData = (data) => axios.post(`${API}/master-data`, data);
export const updateMasterData = (id, data) => axios.put(`${API}/master-data/${id}`, data);
export const deleteMasterData = (id) => axios.delete(`${API}/master-data/${id}`);
export const approveMasterDataChange = (id) => axios.post(`${API}/master-data/${id}/approve`);
export const rejectMasterDataChange = (id, notes) => axios.post(`${API}/master-data/${id}/reject`, { notes });
export const matchMasterData = (supplier_name, supplier_article_number) =>
  axios.get(`${API}/master-data/match`, { params: { supplier_name, supplier_article_number } });
export const importMasterData = (rows) => axios.post(`${API}/master-data/import`, rows);
export const extractMasterDataFromPdf = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/master-data/extract-pdf`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000,
  });
};
export const getPdfExtractionStatus = (jobId) => axios.get(`${API}/master-data/extract-pdf/${jobId}`);
export const uploadMasterDataSheet = (masterId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/master-data/${masterId}/upload-datasheet`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// External Companies
export const getExternalCompanies = () => axios.get(`${API}/external-companies`);
export const createExternalCompany = (data) => axios.post(`${API}/external-companies`, data);
export const approveExternalCompany = (id, status) => axios.put(`${API}/external-companies/${id}/approve`, { status });
export const registerExternalCompany = (data) => axios.post(`${API}/external-companies/register`, data);
export const getMyExternalCompany = () => axios.get(`${API}/external-companies/me`);
export const getExternalCompanyUsers = (id) => axios.get(`${API}/external-companies/${id}/users`);

// AI Search
export const aiSearch = (query) => axios.post(`${API}/ai/search`, { query });

// Material Approval
export const getPendingMaterials = () => axios.get(`${API}/admin/pending-materials`);
export const approveMaterial = (id, status) => axios.put(`${API}/materials/${id}/approval`, { status });

// Countries
export const getCountries = () => axios.get(`${API}/sites/countries`);

// Units
export const getUnits = () => axios.get(`${API}/units`);
export const createUnit = (data) => axios.post(`${API}/units`, data);
export const updateUnit = (id, data) => axios.put(`${API}/units/${id}`, data);
export const deleteUnit = (id) => axios.delete(`${API}/units/${id}`);
export const seedUnits = () => axios.post(`${API}/units/seed`);

// Notifications
export const getNotifications = (params) => axios.get(`${API}/admin/notifications`, { params });
export const triggerEscalationCheck = () => axios.post(`${API}/admin/notifications/trigger-check`);
export const getNotificationStats = () => axios.get(`${API}/admin/notifications/stats`);
export const resendNotification = (notificationId) => axios.post(`${API}/admin/notifications/${notificationId}/resend`);
export const runWeeklyOfferDigest = () => axios.post(`${API}/offers/admin/run-weekly-digest`);
export const sendTestOfferDigest = () => axios.post(`${API}/offers/admin/send-test-digest`);


// Platform Settings
export const getPlatformSettings = () => axios.get(`${API}/admin/platform-settings`);
export const getPlatformSettingsRaw = () => axios.get(`${API}/admin/platform-settings/raw`);
export const updatePlatformSettings = (data) => axios.put(`${API}/admin/platform-settings`, data);

// Legal Pages
export const getLegalPages = () => axios.get(`${API}/legal-pages`);
export const getLegalPage = (slug) => axios.get(`${API}/legal-pages/${slug}`);
export const updateLegalPage = (slug, data) => axios.put(`${API}/legal-pages/${slug}`, data);

// Transactions
export const getTransactions = (params) => axios.get(`${API}/transactions`, { params });
export const getTransactionDetail = (id) => axios.get(`${API}/transactions/${id}`);
export const updateTransactionStatus = (id, status) => axios.put(`${API}/transactions/${id}/status`, { status });
export const markTransactionShipped = (id, data) => axios.put(`${API}/transactions/${id}/ship`, data);
export const markTransactionDelivered = (id, data) => axios.put(`${API}/transactions/${id}/deliver`, data);
export const createMarketplacePaymentCheckout = (transactionId, originUrl) =>
  axios.post(`${API}/transactions/${transactionId}/payment/checkout`, { origin_url: originUrl });
export const getMarketplacePaymentStatus = (transactionId, sessionId) =>
  axios.get(`${API}/transactions/${transactionId}/payment/status/${sessionId}`);
export const getShippingCarriers = () => axios.get(`${API}/shipping/carriers`);
export const getMarketplaceInvoicePdfUrl = (transactionId) =>
  `${API}/transactions/${transactionId}/invoice/pdf`;
export const downloadMarketplaceInvoice = (transactionId) =>
  axios.get(`${API}/transactions/${transactionId}/invoice/pdf`, { responseType: 'blob' });

// Phase D — Cancellation & Disputes
export const cancelTransaction = (transactionId, reason) =>
  axios.post(`${API}/transactions/${transactionId}/cancel`, { reason });
export const openDispute = (transactionId, payload) =>
  axios.post(`${API}/transactions/${transactionId}/disputes`, payload);
export const getDisputeForTransaction = (transactionId) =>
  axios.get(`${API}/transactions/${transactionId}/disputes`);
export const listMyDisputes = (status) =>
  axios.get(`${API}/disputes`, { params: status ? { status } : {} });
export const addDisputeMessage = (disputeId, message) =>
  axios.post(`${API}/disputes/${disputeId}/messages`, { message });
export const adminListDisputes = (status) =>
  axios.get(`${API}/admin/disputes`, { params: status ? { status } : {} });
export const adminResolveDispute = (disputeId, payload) =>
  axios.post(`${API}/admin/disputes/${disputeId}/resolve`, payload);
export const uploadShippingDocument = (file, transactionId) => {
  const formData = new FormData();
  formData.append('file', file);
  const params = transactionId ? `?transaction_id=${encodeURIComponent(transactionId)}` : '';
  return axios.post(`${API}/upload/shipping-document${params}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// Ratings
export const getRatingCategories = () => axios.get(`${API}/rating-categories`);
export const createRatingCategory = (data) => axios.post(`${API}/rating-categories`, data);
export const updateRatingCategory = (id, data) => axios.put(`${API}/rating-categories/${id}`, data);
export const deleteRatingCategory = (id) => axios.delete(`${API}/rating-categories/${id}`);
export const submitRating = (data) => axios.post(`${API}/ratings`, data);
export const getGroupRatings = (groupId) => axios.get(`${API}/ratings/group/${groupId}`);
export const getSiteRatings = (siteId) => axios.get(`${API}/ratings/site/${siteId}`);
export const getSellerRatingSummaries = (groupIds, siteIds) => axios.get(`${API}/ratings/seller-summary`, { params: { group_ids: groupIds, site_ids: siteIds } });
export const getTransactionRatings = (txnId) => axios.get(`${API}/ratings/transaction/${txnId}`);

// File Upload
export const uploadMaterialFile = (file, materialId, attachmentType, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  const params = new URLSearchParams();
  if (materialId) params.append('material_id', materialId);
  if (attachmentType) params.append('attachment_type', attachmentType);
  return axios.post(`${API}/upload/material-file?${params.toString()}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
};
export const deleteFile = (fileId) => axios.delete(`${API}/files/${fileId}`);
export const getFileUrl = (fileId) => `${BACKEND_URL}/api/files/${fileId}`;

// Rewrites stored absolute file URLs (which may point at a stale preview host)
// to the current backend so links/iframes always work across environments.
export const normalizeFileUrl = (url) => {
  if (!url) return url;
  const idx = url.indexOf('/api/files/');
  if (idx < 0 || !BACKEND_URL) return url;
  return `${BACKEND_URL}${url.slice(idx)}`;
};

// AI PDF Extraction
export const extractPdfData = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/extract-pdf`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 60000,
  });
};

// Fee Config
export const getFeeConfig = () => axios.get(`${API}/admin/fee-config`);
export const updateFeeConfig = (data) => axios.put(`${API}/admin/fee-config`, data);

// Savings Dashboard
export const getSavingsDashboard = () => axios.get(`${API}/dashboard/savings`);

// Internal Window
export const updateSkuInternalWindow = (skuId, data) => axios.put(`${API}/skus/${skuId}/internal-window`, data);

// Material Matching
export const getMatchingMatches = (params) => axios.get(`${API}/matching/matches`, { params });
export const getMatchingStats = () => axios.get(`${API}/matching/stats`);
export const getMatchingCockpit = () => axios.get(`${API}/matching/cockpit`);


// Analytics
export const getAnalyticsTrends = (months) => axios.get(`${API}/analytics/trends`, { params: { months } });
export const getAnalyticsSitePerformance = () => axios.get(`${API}/analytics/site-performance`);
export const getAnalyticsMatchingAnalytics = () => axios.get(`${API}/analytics/matching-analytics`);

// Filter Presets
export const getFilterPresets = () => axios.get(`${API}/filter-presets`);
export const createFilterPreset = (data) => axios.post(`${API}/filter-presets`, data);
export const updateFilterPreset = (presetId, data) => axios.put(`${API}/filter-presets/${presetId}`, data);
export const deleteFilterPreset = (presetId) => axios.delete(`${API}/filter-presets/${presetId}`);
export const markPresetUsed = (presetId) => axios.put(`${API}/filter-presets/${presetId}/use`);

// Wanted Materials
export const getWantedAds = (params) => axios.get(`${API}/wanted`, { params });
export const getRecentWantedAds = (limit = 5) => axios.get(`${API}/wanted/public-recent`, { params: { limit } });
export const getWantedMatchesForMaterial = (materialId, limit = 4) =>
  axios.get(`${API}/wanted/matches-for-material/${materialId}`, { params: { limit } });
export const createWantedAd = (data) => axios.post(`${API}/wanted`, data);
export const updateWantedAd = (id, data) => axios.put(`${API}/wanted/${id}`, data);
export const deleteWantedAd = (id) => axios.delete(`${API}/wanted/${id}`);
export const getMyWantedAds = () => axios.get(`${API}/wanted/my-ads`);
export const getMyWantedMatches = () => axios.get(`${API}/wanted/my-matches`);
export const fulfillWantedAd = (id, data) => axios.post(`${API}/wanted/${id}/fulfill`, data);

// Structured Offers (Gesuch → Angebot lifecycle)
export const createOffer = (data) => axios.post(`${API}/offers`, data);
export const getMyOffers = () => axios.get(`${API}/offers/my-offers`);
export const getOffersForWanted = (wantedId) => axios.get(`${API}/offers/by-wanted/${wantedId}`);
export const getOffer = (offerId) => axios.get(`${API}/offers/${offerId}`);
export const acceptStructuredOffer = (offerId) => axios.post(`${API}/offers/${offerId}/accept`);
export const declineStructuredOffer = (offerId) => axios.post(`${API}/offers/${offerId}/decline`);
export const counterStructuredOffer = (offerId, data) => axios.post(`${API}/offers/${offerId}/counter`, data);
export const confirmStructuredOffer = (offerId) => axios.post(`${API}/offers/${offerId}/confirm`);
export const withdrawStructuredOffer = (offerId) => axios.delete(`${API}/offers/${offerId}`);

// Messaging
export const getMessageThreads = () => axios.get(`${API}/messages/threads`);
export const getMessageThread = (threadId) => axios.get(`${API}/messages/threads/${threadId}`);
export const createMessageThread = (wantedId, content) =>
  axios.post(`${API}/messages/threads`, { wanted_id: wantedId, content });
export const sendMessageReply = (threadId, content) =>
  axios.post(`${API}/messages/threads/${threadId}`, { content });
export const getMessageUnreadCount = () => axios.get(`${API}/messages/unread-count`);
export const acceptOffer = (threadId, data) => axios.post(`${API}/messages/threads/${threadId}/accept-offer`, data);
export const getThreadOrder = (threadId) => axios.get(`${API}/messages/threads/${threadId}/order`);

// Notification Preferences
export const updateNotificationPreferences = (notification_frequency) =>
  axios.put(`${API}/auth/notification-preferences`, { notification_frequency });

export const updateEmailPreferences = (email_preferences) =>
  axios.put(`${API}/auth/email-preferences`, { email_preferences });

// Manufacturers
export const getManufacturers = (params) => axios.get(`${API}/manufacturers`, { params });
export const searchManufacturers = (q) => axios.get(`${API}/manufacturers/search`, { params: { q } });
export const createManufacturer = (data) => axios.post(`${API}/manufacturers`, data);
export const updateManufacturer = (id, data) => axios.put(`${API}/manufacturers/${id}`, data);
export const deactivateManufacturer = (id) => axios.delete(`${API}/manufacturers/${id}`);
export const mergeManufacturers = (source_id, target_id) => axios.post(`${API}/manufacturers/merge`, { source_id, target_id });
export const getManufacturerCategories = () => axios.get(`${API}/manufacturers/categories`);
export const getManufacturerUoms = () => axios.get(`${API}/manufacturers/uoms`);
export const getManufacturerSuggestions = () => axios.get(`${API}/manufacturers/suggestions`);
export const suggestManufacturer = (name, reason) => axios.post(`${API}/manufacturers/suggestions`, { name, reason });
export const approveSuggestion = (id) => axios.put(`${API}/manufacturers/suggestions/${id}/approve`);
export const rejectSuggestion = (id) => axios.put(`${API}/manufacturers/suggestions/${id}/reject`);
export const importManufacturersCsv = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/manufacturers/import-csv`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const confirmManufacturersCsvImport = (items) => axios.post(`${API}/manufacturers/import-csv/confirm`, items);
export const getListingScores = (params) => axios.get(`${API}/manufacturers/listing-scores`, { params });
export const resolveManufacturer = (name) => axios.get(`${API}/manufacturers/resolve`, { params: { name } });
export const autoLinkPreview = () => axios.post(`${API}/manufacturers/auto-link/preview`);
export const autoLinkConfirm = (items) => axios.post(`${API}/manufacturers/auto-link/confirm`, items);
export const getRenameLog = (params = {}) => axios.get(`${API}/manufacturers/rename-log`, { params });
export const undoRename = (logId) => axios.post(`${API}/manufacturers/rename-log/${logId}/undo`);

// Verticals (Phase 1 — multi-vertical marketplace)
export const getVerticals = () => axios.get(`${API}/verticals`);
export const getVerticalCategories = (vertical, activeOnly = true) =>
  axios.get(`${API}/verticals/categories`, { params: { vertical, active_only: activeOnly } });
export const getVerticalCategoryTree = (vertical, activeOnly = true) =>
  axios.get(`${API}/verticals/categories/tree`, { params: { vertical, active_only: activeOnly } });
export const createVerticalCategory = (data) => axios.post(`${API}/verticals/categories`, data);
export const updateVerticalCategory = (nodeId, data) => axios.put(`${API}/verticals/categories/${nodeId}`, data);
export const deleteVerticalCategory = (nodeId) => axios.delete(`${API}/verticals/categories/${nodeId}`);

// Machine Manufacturers
export const getMachineManufacturers = (params) => axios.get(`${API}/machine-manufacturers`, { params });
export const searchMachineManufacturers = (q) => axios.get(`${API}/machine-manufacturers/search`, { params: { q } });
export const createMachineManufacturer = (data) => axios.post(`${API}/machine-manufacturers`, data);
export const updateMachineManufacturer = (id, data) => axios.put(`${API}/machine-manufacturers/${id}`, data);
export const deactivateMachineManufacturer = (id) => axios.delete(`${API}/machine-manufacturers/${id}`);
export const getMachineManufacturerCategories = () => axios.get(`${API}/machine-manufacturers/categories`);
export const getMachineModels = (params) => axios.get(`${API}/machine-manufacturers/models`, { params });
export const createMachineModel = (data) => axios.post(`${API}/machine-manufacturers/models`, data);
export const updateMachineModel = (id, data) => axios.put(`${API}/machine-manufacturers/models/${id}`, data);
export const deactivateMachineModel = (id) => axios.delete(`${API}/machine-manufacturers/models/${id}`);
export const mergeMachineModels = (source_id, target_id) => axios.post(`${API}/machine-manufacturers/models/merge`, { source_id, target_id });

// Bug Reports
export const uploadBugAttachment = (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/bug-reports/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
};
export const submitBugReport = (data) => axios.post(`${API}/bug-reports`, data);
export const getMyBugReports = (params) => axios.get(`${API}/bug-reports/my`, { params });
export const getBugReport = (reportId) => axios.get(`${API}/bug-reports/${reportId}`);
export const addBugFollowUp = (reportId, data) => axios.post(`${API}/bug-reports/${reportId}/follow-up`, data);

// Bug Reports — Admin
export const adminGetBugReports = (params) => axios.get(`${API}/admin/bug-reports`, { params });
export const adminGetBugSummary = () => axios.get(`${API}/admin/bug-reports/summary`);
export const adminChangeBugStatus = (reportId, data) => axios.put(`${API}/admin/bug-reports/${reportId}/status`, data);
export const adminAssignBug = (reportId, data) => axios.put(`${API}/admin/bug-reports/${reportId}/assign`, data);
export const adminMarkBugDuplicate = (reportId, data) => axios.put(`${API}/admin/bug-reports/${reportId}/duplicate`, data);
export const adminAddBugNote = (reportId, data) => axios.post(`${API}/admin/bug-reports/${reportId}/notes`, data);
export const adminDeleteBugAttachment = (reportId, attachmentId) => axios.delete(`${API}/admin/bug-reports/${reportId}/attachments/${attachmentId}`);
export const adminBulkBugAction = (data) => axios.post(`${API}/admin/bug-reports/bulk-action`, data);
export const adminGetBugAdmins = () => axios.get(`${API}/admin/bug-reports/admins`);
export const adminGetCriticalAlerts = () => axios.get(`${API}/admin/bug-reports/critical-alerts`);
export const adminDismissCritical = (reportId) => axios.post(`${API}/admin/bug-reports/dismiss-critical/${reportId}`);


// --- Listings (Spare Parts & Machines) ---
export const uploadListingPhoto = (file, listingId, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  const params = new URLSearchParams();
  if (listingId) params.append('listing_id', listingId);
  const q = params.toString();
  return axios.post(`${API}/upload/listing-photo${q ? `?${q}` : ''}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
};
export const uploadListingDocument = (file, listingId, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);
  const params = new URLSearchParams();
  if (listingId) params.append('listing_id', listingId);
  const q = params.toString();
  return axios.post(`${API}/upload/listing-document${q ? `?${q}` : ''}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: onProgress,
  });
};
export const getListings = (params) => axios.get(`${API}/listings`, { params });
export const getMyListings = (params) => axios.get(`${API}/listings/my`, { params });
export const getListing = (id) => axios.get(`${API}/listings/${id}`);
export const createListing = (data) => axios.post(`${API}/listings`, data);
export const updateListing = (id, data) => axios.put(`${API}/listings/${id}`, data);
export const publishListing = (id, expiresInDays) =>
  axios.post(`${API}/listings/${id}/publish`, null, { params: expiresInDays ? { expires_in_days: expiresInDays } : {} });
export const unpublishListing = (id) => axios.post(`${API}/listings/${id}/unpublish`);
export const archiveListing = (id) => axios.post(`${API}/listings/${id}/archive`);
export const markListingSold = (id) => axios.post(`${API}/listings/${id}/mark-sold`);
export const renewListing = (id, { extendDays, reducePricePercent } = {}) => {
  const params = {};
  if (extendDays) params.extend_days = extendDays;
  if (reducePricePercent) params.reduce_price_percent = reducePricePercent;
  return axios.post(`${API}/listings/${id}/renew`, null, { params });
};
export const bulkRenewListings = (listingIds, { extendDays, reducePricePercent } = {}) =>
  axios.post(`${API}/listings/bulk-renew`, {
    listing_ids: listingIds,
    extend_days: extendDays,
    reduce_price_percent: reducePricePercent,
  });
export const setListingVisibility = (id, visibility) =>
  axios.post(`${API}/listings/${id}/visibility`, null, { params: { visibility } });
export const deleteListing = (id) => axios.delete(`${API}/listings/${id}`);
export const scoreListing = (listing_id, criteria) => axios.post(`${API}/listings/score`, { listing_id, criteria });

// --- Enquiries ---
export const createEnquiry = (data) => axios.post(`${API}/enquiries`, data);
export const getMyEnquiries = (params) => axios.get(`${API}/enquiries/my`, { params });
export const getListingEnquiries = (listingId) => axios.get(`${API}/listings/${listingId}/enquiries`);
export const respondEnquiry = (id, data) => axios.post(`${API}/enquiries/${id}/respond`, data);
export const acceptEnquiry = (id) => axios.post(`${API}/enquiries/${id}/accept`);
export const counterBidEnquiry = (id, data) => axios.post(`${API}/enquiries/${id}/counter-bid`, data);
export const rejectCounterBid = (id) => axios.post(`${API}/enquiries/${id}/counter-bid/reject`);
export const closeEnquiry = (id) => axios.post(`${API}/enquiries/${id}/close`);

// --- Verticals & Manufacturer Master Data helpers (already exported above)

// --- Saved Listing Searches (Phase 4 — Buyer-Side) ---
export const getSavedListingSearches = () => axios.get(`${API}/saved-listing-searches`);
export const createSavedListingSearch = (data) => axios.post(`${API}/saved-listing-searches`, data);
export const updateSavedListingSearch = (id, data) => axios.put(`${API}/saved-listing-searches/${id}`, data);
export const deleteSavedListingSearch = (id) => axios.delete(`${API}/saved-listing-searches/${id}`);
export const testSavedListingSearch = (id, limit = 20) =>
  axios.post(`${API}/saved-listing-searches/${id}/test`, null, { params: { limit } });

// --- Spare Parts CSV Bulk Import (Phase 5+) ---
export const getBulkImportTemplate = () =>
  axios.get(`${API}/listings/bulk-import/template`, { responseType: 'blob' });
export const bulkImportListings = (file, dryRun = false) => {
  const formData = new FormData();
  formData.append('file', file);
  return axios.post(`${API}/listings/bulk-import`, formData, {
    params: { dry_run: dryRun },
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};


// --- Guide Section Helpfulness Voting (P3) ---
export const submitGuideVote = ({ sectionId, vote, voterSessionId }) =>
  axios.post(`${API}/guide/vote`, {
    section_id: sectionId,
    vote,
    voter_session_id: voterSessionId,
  });
export const getGuideSectionVotes = (sectionId, voterSessionId) =>
  axios.get(`${API}/guide/vote/${encodeURIComponent(sectionId)}`, {
    params: voterSessionId ? { voter_session_id: voterSessionId } : {},
  });
export const getGuideVoteSummary = () => axios.get(`${API}/guide/vote/summary/all`);

// Personal overview (Mein Bereich)
export const getMyOverview = () => axios.get(`${API}/me/overview`);
export const getMyActivity = (limit = 20) => axios.get(`${API}/me/activity`, { params: { limit } });

// Platform-admin invitations
export const createAdminInvitation = (data) => axios.post(`${API}/admin/admin-invitations`, data);
export const getAdminInvitations = () => axios.get(`${API}/admin/admin-invitations`);
export const revokeAdminInvitation = (inviteId) => axios.delete(`${API}/admin/admin-invitations/${inviteId}`);
export const getAdminInvitationByToken = (token) => axios.get(`${API}/admin-invitations/by-token/${token}`);
export const registerAdminFromInvitation = (token, data) => axios.post(`${API}/admin-invitations/${token}/register`, data);
